import React from 'react';

export const TickIcon: React.FC = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
      <path id="np_tick_1311406_000000" d="M29.375,39.375a10,10,0,1,1,10-10A10,10,0,0,1,29.375,39.375ZM25.966,29.153l2.156,2.034,3.91-5.027a.98.98,0,1,1,1.546,1.2l-4.571,5.878a.979.979,0,0,1-1.445.11l-2.939-2.776a.979.979,0,0,1,1.344-1.423Zm3.409,8.508a8.286,8.286,0,1,0-8.286-8.286A8.285,8.285,0,0,0,29.375,37.661Z" transform="translate(-19.375 -19.375)"/>
  </svg>
  );
}
